import * as React from 'react';
import { RowComponentProps } from 'ui/common/types';
import { MeatballMenu, Permission, PromptConfirmationModal } from 'ui';

import styles from './comment-tile.scss';

/**
 * @interface CommentTileProps
 * Properties for Comment component.
 */
interface CommentTileTranslations {
  /**
   * The text for title in the confimation modal
   */
  textTitle?: string;
  /**
   * The text for description in the confimation modal
   */
  textConfirmDelete?: string;
  /**
   * The label text for the cancel button in the confimation modal
   */
  textCancel?: string;
  /**
   * The label text for the delete button in the confimation modal
   */
  textDelete?: string;
}

export type CommentTileProps = RowComponentProps & CommentTileTranslations;

/**
 * Creates Comment component. Represents each block of listed comments.
 *
 */
export class CommentTile extends React.PureComponent<CommentTileProps, any> {
  public static defaultProps: Partial<CommentTileProps> = {
    enabledChildEntityOperations: { remove: false}
  };

  private handleDeleteComment = () => {
    if (this.props.onDeleteDocumentItem) {
      this.props.onDeleteDocumentItem();
    }
  };

  public render() {
    const {enabledChildEntityOperations, textConfirmDelete, textCancel, textDelete} = this.props;
    const deleteConfirmationModal =
                      <PromptConfirmationModal
                          title={textDelete}
                          description={textConfirmDelete}
                          continueText={textDelete}
                          cancelText={textCancel}
                          onContinue={this.handleDeleteComment}>

                        <button type="button" className="dropdown-item">{textDelete}</button>
                      </PromptConfirmationModal>;

    const contextMenu =
                  <Permission requireAny="remove" permissions={enabledChildEntityOperations}>
                    <div className={styles.commentMenu}>
                      <MeatballMenu>
                        <Permission requireAll="remove" permissions={enabledChildEntityOperations} isListElement={true}>
                          {deleteConfirmationModal}
                        </Permission>
                      </MeatballMenu>
                    </div>
                  </Permission>;

    const userImg = <div className={styles.userIcon}/>;
    const svgTriangle = <svg viewBox="0 0 20 20" className={styles.svgArrow}>
                         <polygon points="2 1,21 1,21 22" /> </svg>;

    const commentTile = <div className={styles.comment}>
                          {contextMenu}
                          {this.props.children}
                        </div>;

    return (
      <div id={this.props.componentId} className={styles.commentWrapper}>
        {userImg}
        {svgTriangle}
        {commentTile}
      </div>

    );
  }
}
